
const RetroOrganizingPage = () => {
  return (<div>retro organizing page</div>)
}

export default RetroOrganizingPage;